import React from 'react'
import ImageUpload from '../../components/UploadImages/UploadImages'

const Upload = () => {
  return (
    <div>
      <p className='text-center mt-3 mb-3'>Use this form to Upload Images And Videos</p>
      <ImageUpload/>
    </div>
  )
}

export default Upload
